import Ripple from "../ripple"

export default class extends HTMLButtonElement {
	constructor () {
		super()
		new Ripple(this).init()
	}
}
